import { render, staticRenderFns } from "./ComponentCarousel.vue?vue&type=template&id=75274bcf&scoped=true&"
import script from "./ComponentCarousel.vue?vue&type=script&lang=ts&"
export * from "./ComponentCarousel.vue?vue&type=script&lang=ts&"
import style0 from "./ComponentCarousel.vue?vue&type=style&index=0&id=75274bcf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75274bcf",
  null
  
)

export default component.exports